import React, { useState } from 'react';
import DropzoneVisual from './DropzoneVisual';
import clsx from 'clsx';
import Dropzone, { DropEvent } from 'react-dropzone';

interface DropzoneProps {
  accept: string;
  onDropRejected: () => void;
  onDropAccepted: <T extends File>(files: T[], event: DropEvent) => void;
  subTitle: any;
  title: string;
  multiple?: boolean;
  disabled?: boolean;
  height?: string;
}

/**
 * Dropzone component with Blaze Bootstrap styling.
 * @param props
 * @constructor
 */
const BzmDropzone = (props: DropzoneProps) => {
  const [isDragging, setIsDragging] = useState(false);

  const onDragEnter = () => {
    setIsDragging(true);
  };

  const onDragLeave = () => {
    setIsDragging(false);
  };

  return (
    <div
      className={clsx('dropzone', isDragging ? 'dz-drag-hover' : undefined, props.disabled && 'dropzone-disabled')}
      style={props.disabled ? { cursor: 'default' } : { cursor: 'pointer', height: props.height, paddingTop: '9%' }}
    >
      <Dropzone
        onDropRejected={props.onDropRejected}
        onDropAccepted={props.onDropAccepted}
        accept={props.accept}
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        multiple={props.multiple}
      >
        {({ getRootProps, getInputProps }) => (
          <div className={'justify-content-center align-items-center dz-message'} {...getRootProps()}>
            <input {...getInputProps()} />
            <DropzoneVisual subtitle={props.subTitle} title={props.title} />
          </div>
        )}
      </Dropzone>
    </div>
  );
};

export default BzmDropzone;
